var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgHeart = function SvgHeart(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 28.8707C34.7111 31.5766 30.0444 35.2864 28 40C25.9556 35.2864 21.2667 31.5766 13.9333 28.8707L9.73335 27.365C8.22224 26.8412 6.93334 26.2084 5.86667 25.4664C4.84445 24.7245 3.86668 23.6989 2.93335 22.3895C0.977794 19.8145 0 16.8903 0 13.617C0 11.042 0.555555 8.72886 1.66667 6.67758C2.82222 4.58265 4.42223 2.94599 6.46667 1.76759C8.51112 0.589197 10.8444 0 13.4667 0C17.0222 0 20.0889 1.06929 22.6667 3.20785C25.2444 5.34643 27.0222 8.13966 28 11.5876C29.0667 8.09601 30.8444 5.30278 33.3333 3.20785C35.8667 1.06929 38.9111 0 42.4667 0C45.0889 0 47.4222 0.589197 49.4667 1.76759C51.5556 2.94599 53.1556 4.56083 54.2667 6.61211C55.4222 8.66339 56 10.9765 56 13.5516C56 16.7376 55.1111 19.5745 53.3333 22.0622C51.6 24.5063 49.2222 26.2739 46.2 27.365L42 28.8707Z",
    fill: "currentColor"
  })));
};

export default SvgHeart;